import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_DETALLE_DESCARGA_GRADO_3 } from '../../../../config/tables'

function DetalleDescargaGrado3View () {
  return (
    <MuiTable id={TABLA_DETALLE_DESCARGA_GRADO_3} />
  )
}

export default DetalleDescargaGrado3View
